<script setup lang="ts">
import { format } from '@/utils/date-fns';
import i18n from '@/utils/i18n';
import { isToday } from 'date-fns';
import { capitalize } from 'lodash';

interface Props {
  startDate?: any;
  startTime?: any;
  endDate?: any;
  endTime?: any;
}

const props = withDefaults(defineProps<Props>(), {});

const emit = defineEmits(['summary-clicked']);

const getFormattedDate = (selectedDate: any) => {
  if (!selectedDate) return '';
  if (isToday(selectedDate)) return i18n.global.t('global.today');
  return capitalize(format(selectedDate, 'EEEE dd MMMM'));
};
</script>

<template>
  <div class="flex">
    <div v-if="props.startDate && props.startTime" class="mr-6">
      <p class="h800 mb-6">
        {{ $t('global.starts') }}
      </p>
      <div
        @click="emit('summary-clicked')"
        class="bg-neutral-0 rounded-2xl p-8 h700 flex border-1 border-neutral-500 shadow-small mb-6 w-[420px]"
      >
        <fa-icon :icon="['far', 'fa-clock']" class="size-[30px] mr-3 mt-1" />
        <div>
          <p class="h700">{{ getFormattedDate(props.startDate) }}</p>
          <p class="b600">{{ startTime }}</p>
        </div>
      </div>
    </div>

    <div v-if="props.endDate && props.endTime">
      <p class="h800 mb-6">
        {{ $t('global.ends') }}
      </p>
      <div
        @click="emit('summary-clicked')"
        class="bg-neutral-0 rounded-2xl p-8 h700 flex border-1 border-neutral-500 shadow-small mb-6 w-[420px]"
      >
        <fa-icon :icon="['far', 'fa-clock']" class="size-[30px] mr-3 mt-1" />
        <div>
          <p class="h700">{{ getFormattedDate(props.endDate) }}</p>
          <p class="b600">{{ endTime }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
